import { XMLInterfaceObject } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { IInventoryVO } from "./IInventoryVO";

export class VisualVO implements IInventoryVO {
    private _id: number = 0;
    private _inventoryAmount: number = NaN;
    private _colorId: number = 0;
    private _timeleft: number = NaN;

    constructor() {
    }

    public getVisClassName(): string {
        return this.id.toString();
    }

    public fillFromParamXML(wodElement: XMLInterfaceObject): void {
        this.id = parseInt((wodElement['id'] || ''));
    }

    public get id(): number {
        return this._id;
    }

    public set id(value: number) {
        this._id = value;
    }

    public get inventoryAmount(): number {
        return this._inventoryAmount;
    }

    public set inventoryAmount(value: number) {
        this._inventoryAmount = value;
    }
    public get colorId(): number {
        return this._colorId;
    }

    public set colorId(value: number) {
        this._colorId = value;
    }

    public get timeleft(): number {
        return this._timeleft;
    }

    public set timeleft(value: number) {
        this._timeleft = value;
    }

}
classImplementsInterfaces(VisualVO, "IInventoryVO");
